import hcOffcanvasNav from "hc-offcanvas-nav";

/**
 * More configurations can be found at https://github.com/somewebmedia/hc-offcanvas-nav
 * @param {string} menuContainerCssClass - The CSS class of the menu container
 * @param {string} toggleBtnCssClass - The CSS class of the toggle button
 */
function mobileMenu(menuContainerCssClass, toggleBtnCssClass) {
	new hcOffcanvasNav(menuContainerCssClass, {
		disableAt: 1100,
		customToggle: toggleBtnCssClass,
		width: '100%',
		position: 'right',
		bodyInsert: 'prepend',
		levelOpen: 'expand',
		insertClose: false,
		insertBack: false,
		disableBody: false

	});
}


export default mobileMenu;